import {ICON_TYPES} from '../constants';

export const QuotesIcon = () => {
  return (
    <svg
      width='47'
      height='37'
      viewBox='0 0 47 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.48 36.7705C9.33333 36.7705 7.56 36.3505 6.16 35.5105C4.76 34.6705 3.59333 33.5505 2.66 32.1505C1.72667 30.6571 1.02667 28.9771 0.56 27.1105C0.186667 25.2438 0 23.5638 0 22.0705C0 17.4971 1.16667 13.2971 3.5 9.47047C5.92667 5.6438 9.61333 2.5638 14.56 0.230469L15.82 2.75047C13.02 3.9638 10.5933 5.83047 8.54 8.35047C6.48667 10.8705 5.36667 13.4371 5.18 16.0505C4.99333 17.4505 5.08667 18.7571 5.46 19.9705C7.14 18.3838 9.19333 17.5905 11.62 17.5905C14.3267 17.5905 16.6133 18.4771 18.48 20.2505C20.3467 21.9305 21.28 24.2638 21.28 27.2505C21.28 30.0505 20.3 32.3371 18.34 34.1105C16.4733 35.8838 14.1867 36.7705 11.48 36.7705ZM36.96 36.7705C34.8133 36.7705 33.04 36.3505 31.64 35.5105C30.24 34.6705 29.0733 33.5505 28.14 32.1505C27.2067 30.6571 26.5067 28.9771 26.04 27.1105C25.6667 25.2438 25.48 23.5638 25.48 22.0705C25.48 17.4971 26.6467 13.2971 28.98 9.47047C31.4067 5.6438 35.0933 2.5638 40.04 0.230469L41.3 2.75047C38.5 3.9638 36.0733 5.83047 34.02 8.35047C31.9667 10.8705 30.8467 13.4371 30.66 16.0505C30.4733 17.4505 30.5667 18.7571 30.94 19.9705C32.62 18.3838 34.6733 17.5905 37.1 17.5905C39.8067 17.5905 42.0933 18.4771 43.96 20.2505C45.8267 21.9305 46.76 24.2638 46.76 27.2505C46.76 30.0505 45.78 32.3371 43.82 34.1105C41.9533 35.8838 39.6667 36.7705 36.96 36.7705Z'
        fill='#003243'
      />
    </svg>
  );
};

QuotesIcon.iconType = ICON_TYPES.QUOTE_ICON;
